var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value !== null
    ? _c("section", { staticClass: "data pega-print-break-inside-avoid" }, [
        _c(
          "div",
          { attrs: { id: _vm.targetId } },
          [
            _c("p", { staticClass: "h-style-02", class: _vm.titleClass }, [
              _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
            ]),
            _vm._v(" "),
            _c("job-preview-content-data-tooltip"),
            _vm._v(" "),
            _c("div", { staticClass: "palette" }, [
              _c("div", { staticClass: "colorOuter", class: _vm.colorClass }, [
                _c("div", {
                  staticClass: "colorInner",
                  style: "transform: rotate(" + _vm.rotateTurn + "turn);",
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "centerOverlay fwB" }, [
                _c("span", { staticClass: "head mt10 tc" }, [_vm._v("女性")]),
                _vm._v(" "),
                _c("span", { staticClass: "data tr" }, [
                  _vm._v(_vm._s(_vm.value)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "percent" }, [_vm._v("％")]),
                _vm._v(" "),
                _c("div", { staticClass: "north" }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "separator",
                  style:
                    "transform: rotate(" +
                    _vm.rotateTurn +
                    "turn) translate(0px, -50px);",
                }),
              ]),
            ]),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }